const styles = theme => ({
    container: {
        fontFamily: 'VodafoneRg-Regular',
        border: '1px solid #CCCCCC',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        width: '100%',
        overflow: 'hidden',
        marginBottom:'2.5rem'
    },
    heading: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1.5rem',
        margin: 0,
        padding: '30px 16px 20px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
    },
    tableHeaderRow: {
        background: 'rgba(204, 204, 204, 0.09)',
        borderBottom: '1px solid #F2F2F2',
        borderTop: '1px solid #F2F2F2',
        color: '#7E7E7E',
        textAlign: 'left',
    },
    td: {
        padding: '10px 20px',
        textAlign: 'left',
        backgroundColor: 'transparent',
    },
    rankingTd: {
        padding: '10px 20px',
        textAlign: 'left',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        fontWeight: '600'
    },
    th: {
        padding: '10px 20px',
        backgroundColor: 'transparent',
        '&:last-child': {
            textAlign: 'right',
            paddingRight: '20px',
        },
    },
    iconWrapper: {
        padding: '3px',
        paddingRight: '15px',
        textAlign: 'right',
        '& > button': {
            backgroundColor: 'transparent',
            border: 0
        },
    },
    icon: {
        width: '1rem',
        height: '1rem',
        cursor: 'pointer',
        border: '1px solid #6551FF',
        borderRadius: '5px',
        padding: '3px',
        color: '#6551FF',
        boxSizing: 'content-box',
        transition: 'all 0.3s ease',

        '&:hover': {
            border: '1px solid #6551FF',
            backgroundColor: '#6551FF',
            color: '#FFFFFF',
        }
    },
    starIcon: {
        width: '1.5rem',
        height: '1.5rem',
        cursor: 'pointer',
        padding: '3px',
        color: '#FECB00',
        boxSizing: 'content-box',
    },
    buttonWrapper: {
        textAlign: 'center',
        padding: '20px 0px 10px',
        '& > button': {
            width: '140px',
            height: '35px',
            cursor: 'pointer',
            border: '1px solid #6551FF',
            borderRadius: '22.5px',
            color: '#6551FF',
            boxSizing: 'content-box',
            backgroundColor: 'transparent',
            fontSize: '16px',
            transition: 'all 0.3s ease',
        
            '&:hover': {
                border: '1px solid #6551FF',
                backgroundColor: '#6551FF',
                color: '#FFFFFF',
            }
        }
    }
});

export default styles